import { render } from "./TwoReportsection.vue?vue&type=template&id=5bd7348a&scoped=true"
import script from "./TwoReportsection.vue?vue&type=script&lang=js"
export * from "./TwoReportsection.vue?vue&type=script&lang=js"

import "./TwoReportsection.vue?vue&type=style&index=0&id=5bd7348a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5bd7348a"]])

export default __exports__